export enum Profile {
    EINGESCHRAENKTE_MOBILITAET = 1,
    FAMILIEN = 2,
    SENIOREN = 3,
    SPORTLICH = 4,
    SCHULEN = 5
}

export enum Topic {
    POLITIK = 1,
    HERRSCHAFT = 2,
    WIRTSCHAFT = 3,
    RELIGION = 4,
    KULTUR = 5,
    NATUR = 6,
    GESELLSCHAFT = 7
}

export enum Community {
    BALZERS = 'BALZERS',
    TRIESEN = 'TRIESEN',
    TRIESENBERG = 'TRIESENBERG',
    VADUZ = 'VADUZ',
    SCHAAN = 'SCHAAN',
    PLANKEN = 'PLANKEN',
    ESCHEN_NENDELN = 'ESCHEN',
    GAMPRIN_BENDERN = 'GAMPRIN',
    RUGGELL = 'RUGGELL',
    SCHELLENBERG = 'SCHELLENBERG',
    MAUREN_SCHAANWALD = 'MAUREN'
}

export enum Experience {
    NORMAL = 1,
    SPECIAL = 2
}

export enum Favorite {
    FAVORITE = 1,
    NON_FAVORITE = 2
}

export enum ArExperienceChoices {
    MAP_LIECHTENSTEIN = 'LIECHTENSTEIN',
    SCHLOSS_VADUZ = 'SCHLOSS_VADUZ',
    BURG_GUTENBERG = 'BURG_GUTENBERG',
    KASTELL_SCHAN = 'KASTELL_SCHAN',
    KIRCHE_BENDERN = 'KIRCHE_BENDERN',
    UEBERFLUTUNG = 'UEBERFLUTUNG',
    GERICHT = 'GERICHT',
    TORFSTECHER = 'TORFSTECHER',
    WEBSTUHL = 'WEBSTUHL',
    BURG_BUILDER = 'BURG_BUILDER'
}

export const DefaultOnBoardingPoi = 147;
